/* VCTparts delivery info block (snippets/henk-levertijden-dynamisch.liquid).
   Moved out of the snippet so the browser caches it; texts come from the
   #vct-info-i18n JSON.
   Verzenddeadline: dezelfde bron als de verzendtimer in header en winkelwagen
   (Thema-instellingen > Verzending > "shipping_timer_show_until", nu 20:00),
   via data-vct-cutoff op het blok. Tijd altijd in Nederlandse tijd
   (Europe/Amsterdam), ook als de bezoeker in een andere tijdzone zit.
   Verzenddagen: maandag t/m vrijdag. Na de deadline op ma–do: "morgen
   verzonden"; vrijdag na de deadline, zaterdag en zondag: "maandag verzonden".
   Gratis verzending: kost de gekozen variant zelf al minstens de drempel
   (39,-), dan staat er "Gratis verzending" in plaats van "Nog X voor gratis
   verzending". Bedragen zonder euroteken, net als de rest van de winkel.
   Bezorgdatum: voor het land van het domein (data-vct-country, anders de
   hostnaam; alleen NL/BE/DE) wordt de regel "Besteld voor 20:00 -> vandaag
   verzonden" "Besteld voor 20:00 -> morgen (dinsdag 21 oktober) in huis", via
   window.vctVerzenddag.bezorgdatum (assets/vct-verzenddag.js) met transittijd,
   zaterdag en feestdagen uit de thema-instellingen. Geen land of script: de oude
   verzendtekst. Niet op voorraad / Harvest: eigen regel, geen datum. */
(function () {
  if (window.vctLevertijden) return;   // het script kan twee keer op de pagina staan (infoblok + mobiele samenvatting)
  window.vctLevertijden = true;

  const blockEl = document.querySelector('.vct-info-block');
  const FREE_SHIPPING_THRESHOLD = parseInt(blockEl && blockEl.getAttribute('data-vct-free-threshold'), 10) || 3900;

  // Vertalingen (uit het JSON-blok hierboven); valt terug op Nederlands
  let T = {};
  try { T = JSON.parse(document.getElementById('vct-info-i18n').textContent); } catch (e) {}
  function tpl(str, vars) { return String(str || '').replace(/%\{(\w+)\}/g, function (_, k) { return vars[k] != null ? vars[k] : ''; }); }

  // Deadline "HH:MM" uit de thema-instelling (valt terug op 20:00)
  const cutoffEl = document.querySelector('[data-vct-cutoff]');
  const cm = /^(\d{1,2}):(\d{2})/.exec(cutoffEl ? cutoffEl.getAttribute('data-vct-cutoff') || '' : '');
  const CUTOFF_H = cm ? Math.min(23, parseInt(cm[1], 10)) : 20;
  const CUTOFF_M = cm ? Math.min(59, parseInt(cm[2], 10)) : 0;
  const CUTOFF_TEXT = String(CUTOFF_H).padStart(2, '0') + ':' + String(CUTOFF_M).padStart(2, '0');

  // Pijl-icoon uit snippets/vct-icon.liquid (arrow-right)
  const ARROW = '<svg class="vct-icon vct-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';

  // Huidige dag en tijd in Nederland: { dow: 0 (zo) – 6 (za), secs: seconden sinds middernacht }
  const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  let fmt = null;
  try {
    fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
  } catch (e) { fmt = null; }
  function nowNL() {
    const d = new Date();
    if (fmt) {
      try {
        const parts = fmt.formatToParts(d);
        const get = function (t) { const p = parts.find(function (x) { return x.type === t; }); return p ? p.value : ''; };
        const dow = DAYS.indexOf(get('weekday'));
        const h = (parseInt(get('hour'), 10) || 0) % 24;
        if (dow !== -1) return { dow: dow, secs: h * 3600 + (parseInt(get('minute'), 10) || 0) * 60 + (parseInt(get('second'), 10) || 0) };
      } catch (e) {}
    }
    return { dow: d.getDay(), secs: d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds() };
  }
  const CUTOFF_SECS = CUTOFF_H * 3600 + CUTOFF_M * 60;

  /* 'today' | 'tomorrow' | 'monday'. Zelfde bron als kaarten, header en winkelwagen:
     window.vctVerzenddag.status() uit assets/vct-verzenddag.js (geladen in de header).
     Ontbreekt dat script, of valt de deadline niet op het hele uur, dan dezelfde regel hier. */
  function shipStatus(n) {
    if (CUTOFF_M === 0 && window.vctVerzenddag && typeof window.vctVerzenddag.status === 'function') {
      try {
        const st = window.vctVerzenddag.status(CUTOFF_H);
        if (st === 'today' || st === 'tomorrow' || st === 'monday') return st;
      } catch (e) {}
    }
    if (n.dow >= 1 && n.dow <= 5 && n.secs < CUTOFF_SECS) return 'today';
    if (n.dow >= 1 && n.dow <= 4) return 'tomorrow';
    return 'monday';
  }
  // Land van het domein: localization.country uit de snippet, anders de hostnaam
  function shopCountry() {
    const c = String((blockEl && blockEl.getAttribute('data-vct-country')) || '').toUpperCase();
    if (c === 'NL' || c === 'BE' || c === 'DE') return c;
    if (c) return null;   // ander land (bv. FR, LU): geen bezorgdatum
    const host = window.location.hostname;
    if (/(^|\.)vctparts\.nl$/.test(host)) return 'NL';
    if (/(^|\.)vctparts\.be$/.test(host)) return 'BE';
    if (/(^|\.)vctparts\.de$/.test(host)) return 'DE';
    return null;
  }
  const COUNTRY = shopCountry();
  const LANG = String((blockEl && blockEl.getAttribute('data-vct-locale')) || 'nl').toLowerCase().split('-')[0];
  const TRANSIT = {};
  String((blockEl && blockEl.getAttribute('data-vct-transit')) || '').split(',').forEach(function (p) {
    const kv = p.split(':');
    if (kv.length === 2 && kv[1].trim() !== '') TRANSIT[kv[0].trim()] = parseInt(kv[1], 10);
  });

  // Bezorgdatum voor het land, of null (geen land / script ontbreekt)
  function delivery() {
    const V = window.vctVerzenddag;
    if (!COUNTRY || !V || typeof V.bezorgdatum !== 'function' || typeof V.datumTekst !== 'function') return null;
    try {
      return V.bezorgdatum(COUNTRY, CUTOFF_H + CUTOFF_M / 60, {
        transit: TRANSIT[COUNTRY],
        zaterdag: blockEl && blockEl.getAttribute('data-vct-saturday') === 'true',
        feestdagen: (blockEl && blockEl.getAttribute('data-vct-holidays')) || ''
      });
    } catch (e) { return null; }
  }

  // Vandaag nog verzonden? Alleen op ma–vr vóór de deadline (en geen feestdag, als de bezorgdatum meetelt).
  function shipsToday(n) {
    if (shipStatus(n) !== 'today') return false;
    const d = delivery();
    return d ? d.vandaag : true;
  }

  function setShippingMessages() {
    const nodes = document.querySelectorAll('.vct-shipping-message');
    if (!nodes.length) return;
    const n = nowNL();
    let html;
    nodes.forEach(function (el) {
      const block = el.closest('[data-vct-variant]');
      const free = block && block.dataset.vctFree ? block.dataset.vctFree : '';
      const verzending = free ? (T.shippedFree || '<strong>gratis</strong> verzonden') : (T.shipped != null ? T.shipped : 'verzonden');
      const d = delivery();
      if (d) {
        // "morgen (dinsdag 21 oktober) in huis" / "woensdag 22 oktober in huis"
        const datum = window.vctVerzenddag.datumTekst(d.datum, LANG);
        const rel = d.dagen === 0 ? T.today : (d.dagen === 1 ? T.tomorrow : null);
        const dateTxt = rel ? tpl(T.deliverRelative || '%{day} (%{date})', { day: rel, date: datum }) : tpl(T.deliverOn || '%{date}', { date: datum });
        const promise = tpl(T.deliverPromise || '%{date} %{free}in huis', { date: dateTxt, free: free ? (T.deliverFree || '<strong>gratis</strong> ') : '' });
        html = d.vandaag
          ? tpl(T.deliverBefore || "Besteld voor <strong>%{time}</strong> %{arrow} <span class='vct-promise'>%{promise}</span>", { time: CUTOFF_TEXT, promise: promise, arrow: ARROW })
          : tpl(T.deliverNow || "Nu besteld %{arrow} <span class='vct-promise'>%{promise}</span>", { promise: promise, arrow: ARROW });
      } else if (shipsToday(n)) {
        html = tpl(T.orderBefore || "Besteld voor <strong>%{time}</strong> %{arrow} <span class='vct-promise'>%{day} %{shipped}</span>", { time: CUTOFF_TEXT, day: T.today || 'vandaag', shipped: verzending, arrow: ARROW });
      } else {
        // ma–do na de deadline: morgen. Vrijdag na de deadline, zaterdag en zondag: maandag.
        const day = shipStatus(n) === 'tomorrow' ? (T.tomorrow || 'morgen') : (T.monday || 'maandag');
        html = tpl(T.orderNow || "Nu besteld %{arrow} <span class='vct-promise'>%{day} %{shipped}</span>", { day: day, shipped: verzending, arrow: ARROW });
      }
      if (el.innerHTML !== html) el.innerHTML = html;
    });
  }

  function startTimer() {
    const badges = document.querySelectorAll('.vct-countdown-badge');
    let lastToday = null;
    function update() {
      const n = nowNL();
      const today = shipsToday(n);
      // Deadline net gepasseerd: de tekst ernaast meteen bijwerken
      if (lastToday !== null && lastToday !== today) setShippingMessages();
      else if (n.secs % 60 === 0) setShippingMessages();   // nieuwe dag (bezorgdatum) zonder herladen
      lastToday = today;
      const diff = CUTOFF_SECS - n.secs;
      badges.forEach(function (badge) {
        if (!today || diff <= 0) { badge.style.display = 'none'; return; }
        badge.style.display = 'flex';
        const timerEl = badge.querySelector('.vct-timer');
        if (!timerEl) return;
        const h = Math.floor(diff / 3600);
        const m = Math.floor((diff % 3600) / 60);
        const s = diff % 60;
        timerEl.textContent =
          String(h).padStart(2, '0') + ':' +
          String(m).padStart(2, '0') + ':' +
          String(s).padStart(2, '0');
      });
    }
    update();
    setInterval(update, 1000);
  }

  function currentVariantId() {
    // Prefer the main product form: its variant input sits outside the <form> (form="main-product-form-…")
    const input = document.querySelector('[name="id"][form^="main-product-form"]')
      || document.querySelector('form[id^="main-product-form"] [name="id"]')
      || document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return String(input.value);
    const param = new URLSearchParams(window.location.search).get('variant');
    return param ? String(param) : null;
  }

  // Varianten tonen/verbergen, per groep (infoblok en mobiele samenvatting apart)
  function showVariant(id) {
    const groups = document.querySelectorAll('.vct-info-block, [data-vct-variant-group]');
    groups.forEach(function (group) {
      const blocks = group.querySelectorAll('[data-vct-variant]');
      if (!blocks.length) return;
      let found = false;
      blocks.forEach(function (b) {
        const match = b.dataset.vctVariant === id;
        if (match) found = true;
        b.hidden = !match;
      });
      if (!found) blocks[0].hidden = false;
    });
    setShippingMessages();
    renderThreshold();
  }

  let lastVariantId = null;
  function syncVariant() {
    const id = currentVariantId();
    if (id && id !== lastVariantId) {
      lastVariantId = id;
      showVariant(id);
    }
  }

  // Bedrag zoals in de rest van de winkel: 12,50 / 12,- (zonder euroteken)
  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',').replace(/,00$/, ',-');
  }

  // Kost de getoonde variant zelf al minstens de drempel?
  function variantIsFree() {
    if (!blockEl) return false;
    const visible = blockEl.querySelector('[data-vct-variant]:not([hidden])');
    return !!(visible && visible.dataset.vctFree);
  }

  let cartTotal = null;   // null = winkelwagen (nog) niet bekend
  function renderThreshold() {
    const titleEl      = document.getElementById('vct-threshold-title');
    const subEl        = document.getElementById('vct-threshold-sub');
    const progressWrap = document.getElementById('vct-progress-wrap');
    const progressFill = document.getElementById('vct-progress-fill');
    const truckWrap    = document.querySelector('.vct-icon-wrap--truck');
    if (!titleEl || !subEl || !progressWrap || !progressFill) return;

    if (variantIsFree()) {
      // Het product zelf haalt de drempel al: geen "Nog X" tonen
      titleEl.innerHTML = '<span class="vct-text-success">' + (T.freeProductTitle || 'Gratis verzending') + '</span>';
      subEl.innerHTML   = T.freeProductSub || 'Dit product wordt gratis verzonden';
      progressWrap.style.display = 'none';
      if (truckWrap) truckWrap.classList.add('vct-icon-wrap--free');
      return;
    }
    if (cartTotal === null) return;

    const missing = FREE_SHIPPING_THRESHOLD - cartTotal;
    const pct     = Math.min(100, Math.round((cartTotal / FREE_SHIPPING_THRESHOLD) * 100));
    if (missing <= 0) {
      titleEl.innerHTML = '<span class="vct-text-success">' + (T.freeTitle || 'Gratis verzending van toepassing!') + '</span>';
      subEl.innerHTML   = T.freeSub || 'Je bestelling wordt gratis verzonden';
      progressWrap.style.display = 'none';
      if (truckWrap) truckWrap.classList.add('vct-icon-wrap--free');
    } else {
      titleEl.innerHTML = tpl(T.missing || 'Nog <strong>%{amount}</strong> voor gratis verzending', { amount: money(missing) });
      subEl.innerHTML   = T.freeFrom || 'Gratis verzending vanaf 39,-';
      progressWrap.style.display = 'block';
      progressFill.style.width   = pct + '%';
      if (truckWrap) truckWrap.classList.remove('vct-icon-wrap--free');
    }
  }

  function updateThreshold() {
    renderThreshold();   // gratis-product meteen, zonder op de winkelwagen te wachten
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartTotal = parseInt(cart.total_price, 10) || 0;
        renderThreshold();
      })
      .catch(function () {
        // Winkelwagen niet op te halen: toon de vaste drempel in plaats van "Laden..."
        const titleEl = document.getElementById('vct-threshold-title');
        if (titleEl && titleEl.querySelector('.vct-row-loading')) titleEl.innerHTML = T.freeFrom || 'Gratis verzending vanaf 39,-';
      });
  }

  function init() {
    lastVariantId = currentVariantId();
    if (lastVariantId) showVariant(lastVariantId); else setShippingMessages();
    startTimer();
    updateThreshold();
    setInterval(syncVariant, 400);
    window.addEventListener('popstate', syncVariant);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') syncVariant();
    });
    document.addEventListener('cart:updated', updateThreshold);
    const cartCount = document.querySelector('[data-cart-count], .cart-count, #cart-count, .cart__count');
    if (cartCount) new MutationObserver(updateThreshold).observe(cartCount, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
